import { FilterDefinition } from '../StagingFilterBuilder';
import { BooleanFilter, ContainsTextFilter } from '../../../../redux/constants/filters';
import BooleanFilterOption from './BooleanFilterOption';
import TextFilterPopover from './TextFilterPopover';

export const nameFilter = new FilterDefinition(
  TextFilterPopover,
  'name',
  'Name',
  {},
  (v) => new ContainsTextFilter({ key: 'name', getter: (g) => g.name, fragment: v })
);

export function buildIsSelectedFilter({ selectedTargets }) {
  return new FilterDefinition(
    BooleanFilterOption,
    'selected_only',
    'Only Selected',
    {},
    () =>
      new BooleanFilter({
        key: 'selected_only',
        getter: (g) => g.name,
        evaluation: (id) => selectedTargets.includes(id),
      })
  );
}
